import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const GlobeIcon = ({
  width = 16,
  height = 16,
  stroke = '#52575C',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M8 14.666c3.682 0 6.667-2.984 6.667-6.666 0-3.682-2.985-6.667-6.667-6.667S1.333 4.318 1.333 8 4.318 14.666 8 14.666zM1.333 8h13.334"
    />
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M8 1.333C9.667 3.159 10.615 5.528 10.667 8c-.052 2.472-1 4.84-2.667 6.666C6.332 12.841 5.385 10.472 5.333 8c.052-2.472 1-4.841 2.667-6.667v0z"
    />
  </svg>
);
